// Pacote 45 (PR #74) — logo do app reutilizável.
// Renderiza /logo.png (gerado de resources/logo-rh.jpeg) num <img>
// quadrado com borda arredondada — mesmo treatment do app icon iOS.
//
// Substitui o que antes era um Sparkles do lucide-react dentro de um
// gradient div. Usa imagem real do brand "Finanças R e H".
export function BrandMark({
  size = 36,
  className,
}: {
  size?: number
  className?: string
}) {
  return (
    <img
      src="/logo.png"
      alt="Finanças R e H"
      width={size}
      height={size}
      className={`rounded-xl object-cover shrink-0 ${className ?? ""}`}
      style={{ width: size, height: size }}
    />
  )
}
